export default __webpack_public_path__ + "static/media/avatar.2e4ef16d.png";